"use strict";

//	Kilopix

import * as kpc from "../../@kilopix/core.module";
import * as kpm from "../../@kilopix/methods.module";
import * as kpu from "../../@kilopix/utils.module";

//	Modules

import { AppInterface, activeImageDisplacement } from "../app.interface";

//	Slider

export class Slider {
	constructor() {
		if ( kpm.hasClass(document.body, "homepage") ) {
			this.root = document.getElementById( "slider" );
			this.image = document.getElementById( "slider-image" );
			this.thumbnailsWrap = document.getElementById( "slider-thumbnails" );
			this.thumbnailsScroll = this.thumbnailsWrap.querySelector( ".scroll" );
			this.thumbnails = this.thumbnailsWrap.querySelectorAll( "li" );
			this.thumbnailsScrollTimeout = null;
			this.isChanging = false;
			this.direction = "up";
			this.index = -1;
		}
	}

	//	Run
	
	run() {
		this.initThumbnails();
		kpm.trigger( this.thumbnails[0].querySelector("a"), "click" );
	}

	//	Resize

	resize() {
		if ( AppInterface.appMediaQuery < 48 ) {
			//	Resize thumbnails

			let itemWidth = Math.round( window.innerWidth / 2 );

			//this.thumbnailsWrap.style.height = `${itemWidth * (((100 / 4) * 3) / 100)}px`;
			this.thumbnailsWrap.querySelector( "ul" ).style.width = `${itemWidth * this.thumbnails.length}px`;
			this.thumbnails.forEach( self => {
				self.style.width = `${itemWidth}px`;
			});

			//console.log( this.thumbnails[0].offsetHeight )
			this.thumbnailsWrap.style.height = `${this.thumbnails[0].offsetHeight}px`;
		} else {
			//	Reset thumbnails
			
			this.thumbnailsWrap.removeAttribute( "style" );
			this.thumbnailsWrap.querySelectorAll( "*" ).forEach( self => {
				self.removeAttribute( "style" );
			});
		}
	}

	//	Init thumbnails

	initThumbnails() {
		this.thumbnailsWrap.querySelectorAll( "a" ).forEach(( self, index ) => {
			self.addEventListener( "click", ( e ) => {
				if ( !this.isChanging && this.index != index ) {
					this.isChanging = true;
					this.direction = ( index < this.index ) ? "down" : "up";
					this.index = index;

					// EDIT ALE - START
					// prendo l'URL dell'immagine piccola
					let thumbImg = e.target.getElementsByTagName( "img" )[0];
					let thumbSrc = thumbImg.src;
					// calcolo le dimensioni che deve avere l'immagine grande, aggiungendo un 10% per i margini esterni, arrotondandoli all'unit�
					let bb_image = this.image.getBoundingClientRect();
					let bigSrc = thumbSrc.replace(/\/(\d+)x(\d+)\//, "/" + Math.round(bb_image.width * 1.1).toString() + "x" + Math.round(bb_image.height * 1.1).toString() + "/");
					// prima e dopo
					console.log("piccola: " + thumbSrc);
					console.log("grande: " + bigSrc);

					// MORE INFO centralizzato nel tag #slider
					let moreInfo = this.root.dataset.moreinfo;
					//console.log(moreInfo);

					// EDIT ALE - END

					this.loadNewImage({
						src: bigSrc,
						url: self.getAttribute( "href" ),
						title: self.querySelector( "h2" ).textContent,
						text: self.querySelector("p").textContent,
						label: moreInfo
					});

					this.thumbnails.forEach( function( self ) {
						kpm.removeClass( self, "current" );
					});

					kpm.addClass( self.parentNode, "current" );
				}

				e.preventDefault();
			});
		});

		//	Scroll effect

		/*
			this.thumbnailsScroll.addEventListener( "scroll", () => {
				let scrollTop = kpc.getScrollTop( this.thumbnailsScroll ),
					id = 0;
	
				this.thumbnails.forEach(( self, index ) => {
					if ( scrollTop > self.offsetTop ) {
						id = index;
					}
				});
	
				clearTimeout( this.thumbnailsScrollTimeout );
				this.thumbnailsScrollTimeout = setTimeout( () => {
					let positionTop = Math.abs( this.thumbnails[id].offsetTop - scrollTop ),
						to = ( positionTop < (this.thumbnails[id].offsetHeight / 2) ) ? id : id + 1;
	
					if ( (id + 2) > (this.thumbnails.length - 1) ) {
						to = this.thumbnails.length - 1;
					}
	
					kpm.to( this.thumbnailsScroll, this.thumbnails[to].offsetTop - scrollTop, 600 );
				}, 1000 );
			});
		*/
	}

	//	Load new image
	
	loadNewImage( data ) {
		let image = new Image();

		image.onload = ( e ) => {
			this.drawNewImage( data );
			this.changeImages();
		}

		image.src = data.src;
	}

	//	Draw new image
	
	drawNewImage( data ) {
		let image = document.createElement( "a" );

		image.href = data.url;
		image.innerHTML = `
			<img src="${data.src}" class="has-displacement">
			<div class="caption">
				<p>${data.title}</p>
				<small>${data.text}</small>
				<div class="button">
					<span data-label="${data.label}">${data.label}</span>
				</div>
			</div>
		`;

		this.image.appendChild( image );

		if ( !kpu.isMobile() ) {
			activeImageDisplacement( image.querySelector(".has-displacement") );
		}
	}

	//	Change images
	
	changeImages() {
		let images = this.image.querySelectorAll( "a" );

		if ( images.length > 1 ) {
			images[0].removeAttribute( "class" );
			images[1].removeAttribute( "class" );

			kpm.addClass( images[0], `push-out-${this.direction}` );
			kpm.addClass( images[1], `push-in-${this.direction}` );

			images[0].addEventListener( kpu.animationEnd(), () => {
				this.image.removeChild( images[0] );
				this.isChanging = false;
			});
		} else {
			this.isChanging = false;
			kpm.addClass( images, "fade-in" );
		}
	}
}